import React from 'react';

const partners = [
  {
    name:        'Huuswerk',
    domain:      'huuswerk.de',
    url:         'https://huuswerk.de',
    tagline:     'Photovoltaik & Energetische Sanierung',
    description:
      'Herzig & Schulze GbR aus Hamburg bietet PV-Anlagen, energetische Sanierungen und Energieberatung – alles aus einer Hand.',
    tags:  ['Photovoltaik', 'Sanierung', 'Energieberatung'],
    kontakt: 'info@huuswerk.de · 040 / 66 93 12 18',
  },
  {
    name:        'Schubert Haustechnik',
    domain:      'heizung-schubert.de',
    url:         'https://heizung-schubert.de',
    tagline:     'Heizung · Sanitär · Solar · Lüftung',
    description:
      'Thomas Schubert – Heizungsmeisterbetrieb aus Westerwalsede mit umfassender Kompetenz in moderner Gebäudetechnik und Wärmepumpensystemen.',
    tags:  ['Heizungsmodernisierung', 'Wärmepumpen', 'Sanitär'],
    kontakt: 'info@heizung-schubert.de · 04269 1356',
  },
  {
    name:        'Hamburg Baugutachten',
    domain:      'hamburg-baugutachten.de',
    url:         'https://hamburg-baugutachten.de',
    tagline:     'DEKRA-zertifizierte Baugutachten',
    description:
      'Sören Niefünd – unabhängiger Baugutachter für Hauskaufberatung, Bauabnahmen, Thermografie und Energieberatung im Großraum Hamburg.',
    tags:  ['Hauskaufberatung', 'Bauabnahmen', 'Thermografie'],
    kontakt: 'info@Hamburg-Baugutachten.de · +49 40 307 46 199',
  },
];

export default function Kooperationspartner() {
  return (
    <section className="section section--alt" id="kooperationspartner">
      <div className="container">

        <div className="koop2__head">
          <span className="section-label">Unser Netzwerk</span>
          <h2 className="section-title">Kooperationspartner</h2>
          <p className="section-subtitle">
            Ausgewählte Fachbetriebe, denen wir vertrauen –
            damit Ihr Projekt in jeder Ecke das Beste bekommt.
          </p>
        </div>

        <div className="koop2__grid">
          {partners.map(p => (
            <div key={p.domain} className="koop2__card">

              <div className="koop2__card-header">
                <img
                  className="koop2__favicon"
                  src={`https://www.google.com/s2/favicons?domain=${p.domain}&sz=64`}
                  alt={p.name}
                />
                <div>
                  <div className="koop2__name">{p.name}</div>
                  <div className="koop2__tagline">{p.tagline}</div>
                </div>
              </div>

              <p className="koop2__description">{p.description}</p>

              <div className="koop2__tags">
                {p.tags.map(t => (
                  <span key={t} className="koop2__tag">{t}</span>
                ))}
              </div>

              <p className="koop2__kontakt">{p.kontakt}</p>

              <a
                className="koop2__link"
                href={p.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                Zur Website <span className="koop2__link-arrow">→</span>
              </a>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
